import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroSegmentedControlStyles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing } from '../../../styles';

export const customSegmentedControlStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroSegmentedControlStyles(context, definition)}
  ${boxSizing}
  :host([appearance="primary"]) ::slotted(zero-segmented-item) {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    border: 1px solid var(--primary-color) !important;
    border-right: none !important;
    justify-content: center;
  }

  :host([appearance='primary']) ::slotted(zero-segmented-item:last-child) {
    border-right: 1px solid var(--primary-color) !important;
  }

  :host([appearance='primary']) ::slotted(zero-segmented-item[aria-checked='true']) {
    background: linear-gradient(90deg, rgb(205 172 31 / 50%) 35%, rgb(116 230 74 / 50%) 100%);
    box-shadow: none;
  }

  :host([appearance='secondary']) ::slotted(zero-segmented-item) {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    border: 1px solid var(--border-1) !important;
    border-right: none !important;
    justify-content: center;
  }

  :host([appearance='secondary']) ::slotted(zero-segmented-item:last-child) {
    border-right: 1px solid var(--border-1) !important;
  }

  :host([appearance='secondary']) ::slotted(zero-segmented-item[aria-checked='true']) {
    background: var(--border-1);
    box-shadow: none;
  }

  :host ::slotted(zero-segmented-item.disabled) {
    cursor: not-allowed;
  }
`;
